<template>
<div>
    <!-- ======= Mobile nav toggle button ======= -->
    <button type="button" class="mobile-nav-toggle d-xl-none"><i class="icofont-navigation-menu"></i></button>

    <!-- ======= Header ======= -->
    <header id="header">
        <div class="d-flex flex-column">

        <div class="profile">
            <img src="/img/profile_photo.jpg" alt="" class="img-fluid rounded-circle">
            <h1 class="text-light"><a href="index.html">Juan Fermín</a></h1>
            <div class="social-links mt-3 text-center">
                <a href="https://twitter.com/juan_fob" target="_blank" class="twitter"><i class="bx bxl-twitter"></i></a>
                <a href="https://github.com/Juanfob" target="_blank" class="github"><i class="bx bxl-github"></i></a>
                <a href="https://www.linkedin.com/in/juan-fermin-oliva-bautista/" target="_blank" class="linkedin" ><i class="bx bxl-linkedin"></i></a>
                <button type="button" @click="$i18n.locale='es'">ES</button>
                <button type="button" @click="$i18n.locale='en'" >EN</button>
            </div>
        </div>

        <nav class="nav-menu">
            <ul>
                <li class="active"><a href="#hero"><i class="bx bx-home"></i> <span>{{ $t('lang.nav.home') }}</span></a></li>
                <li><a href="#about"><i class="bx bx-user"></i> <span>{{ $t('lang.nav.about') }}</span></a></li>
                <li><a href="#skills"><i class="bx bx-user"></i> <span>{{ $t('lang.nav.skills') }}</span></a></li>
                <li><a href="#resume"><i class="bx bx-file-blank"></i> <span>{{ $t('lang.nav.resume') }}</span></a></li>
                <li><a href="#services"><i class="bx bx-server"></i>{{ $t('lang.nav.services') }}</a></li>
                <li><a href="#contact"><i class="bx bx-envelope"></i>{{ $t('lang.nav.contact') }}</a></li>
            </ul>
        </nav><!-- .nav-menu -->
        <button type="button" class="mobile-nav-toggle d-xl-none"><i class="icofont-navigation-menu"></i></button>
    </div>
    </header><!-- End Header -->  
</div>
</template>

<script>
export default {
    name: 'Nav',
    data () {
    return { langs: ['es', 'en'] }
  }
}
</script>

